import type { ComponentType } from 'react';
import {
    CheckCircleIcon,
    LinkIcon,
    PaperClipIcon,
    PencilSquareIcon,
    CalendarDaysIcon,
    ClipboardDocumentListIcon
} from '@heroicons/react/24/outline';

export function isClinicalFormValid(date: string, patientName: string): boolean {
    return date.trim() !== '' && patientName.trim() !== '';
}

export type StepId =
    'form' | 'elastics' | 'instructions' | 'attachment' | 'virtualAppointments' | 'review';

export interface StepMeta {
    id: StepId;
    label: string;
    icon: ComponentType<{ className?: string }>;
}

const ELASTICS_STEP: StepMeta = { id: 'elastics', label: 'Elastics', icon: LinkIcon };

const BASE_STEPS: StepMeta[] = [
    { id: 'form', label: 'Form', icon: PencilSquareIcon },
    { id: 'instructions', label: 'Notes / Instructions', icon: ClipboardDocumentListIcon },
    { id: 'attachment', label: 'Manufacturer', icon: PaperClipIcon },
    { id: 'virtualAppointments', label: 'VAs', icon: CalendarDaysIcon },
    { id: 'review', label: 'Review', icon: CheckCircleIcon }
];

// The odontogram elastics section gets its own step, inserted right after the
// Form step, for both SDI and RDI.
export function buildSteps(): StepMeta[] {
    const formIdx = BASE_STEPS.findIndex((s) => s.id === 'form');
    return [...BASE_STEPS.slice(0, formIdx + 1), ELASTICS_STEP, ...BASE_STEPS.slice(formIdx + 1)];
}
